import { Injectable } from '@angular/core';
import { SystemEnums } from '../_shared/shared.models';

@Injectable({
    providedIn: 'root'
})
export class DictService {
    public systemConstants: SystemEnums = null;

    constructor() {}
}
